export type { QuizBannerBottomProps } from "./QuizBannerBottom";
export { QuizBannerBottom } from "./QuizBannerBottom";
